import { GET_MASTHEAD_AD } from "./mastheadAd.type";

const initialState = {
  mastheadAd: {},
};

const mastheadAdReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MASTHEAD_AD:
      return {
        ...state,
        mastheadAd: action.payload,
      };

    default:
      return state;
  }
};

export default mastheadAdReducer;
